import React from 'react';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import Required from '../Required';
import SelectInput from '../SelectInput/SelectInput';

function HeadSelectComponent({
  classNamePrefix, value, loadOptions, onChange, label = '', required = true, placeholder = 'Введите ФИО', disabled = false,
}) {

  return (
    <>
      <Form.Label style={{ color: '#7F7F7F' }}>
        {label}
        {' '}
        {required && <Required />}
      </Form.Label>
      <SelectInput
        disabled={disabled}
        isClearable
        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        classNamePrefix={classNamePrefix ?? ''}
        value={value}
        placeholder={placeholder}
        defaultOptions={[]}
        defaultValue={[]}
        loadOptions={loadOptions ?? (() => [])}
        onChange={onChange ?? (() => null)}
      />

    </>
  );
}

export default HeadSelectComponent;
